angular.module('app')
    .directive('reg', function() {
        return { template: '<sup class="reg"></sup>'}
    });
